export class InteractionOther {
    static merge(to: InteractionOther, from: InteractionOther) {
        const accumulate = (fieldName: string) => {
            if (from[fieldName]) {
                to[fieldName] = (!to[fieldName] ? 0 : to[fieldName]) + from[fieldName];
            }
        };
        accumulate("pgWelcomeCount");
        accumulate("pgWelcomeTime");
        accumulate("pgAboutCount");
        accumulate("pgAboutTime");
        accumulate("pgSettingsCount");
        accumulate("pgSettingsTime");
        accumulate("pgNoOffersCount");
        accumulate("pgNoOffersTime");
        accumulate("pgLocationCount");
        accumulate("pgLocationTime");
        accumulate("tapFilterCount");
    }

    pgWelcomeCount?: number;
    pgWelcomeTime?: number;
    pgAboutCount?: number;
    pgAboutTime?: number;
    pgSettingsCount?: number;
    pgSettingsTime?: number;
    pgNoOffersCount?: number;
    pgNoOffersTime?: number;
    pgLocationCount?: number;
    pgLocationTime?: number;
    tapFilterCount?: number;
}
